import wrapper from 'wrapper';

let scrollPosition = 0;
let checkpoints = [100, 75, 50, 25]; // should be in descending order

const trackScrollPosition = () => {
    const { scrollHeight } = wrapper.select('.bbc-news-vj-wrapper--full-width');
    const scrollTop = wrapper.getScrollPosition();
    if (scrollTop < scrollPosition) return;
    scrollPosition = scrollTop + 1.1 * window.innerHeight;
    const percentage = (100 * scrollPosition) / scrollHeight;

    // check if percentage passed a checkpoint
    const checkPointIndex = checkpoints.findIndex((cp) => 
        cp <= percentage
    );

    if (checkPointIndex === -1) return;

    const checkPointsToTrack = checkpoints.slice(checkPointIndex);
    checkPointsToTrack.forEach((checkpoint) => 
        wrapper.trackBackgroundEvent('Reader scroll position', `${checkpoint}%`)
    );

    // remove checkpoints that are already tracked
    checkpoints = checkpoints.slice(0, checkPointIndex);
};

export default trackScrollPosition;